import axios from "axios";
import requests from "../util";
const { request } = requests;
const getCredsGoogleLogin = (creds) => {
  const client = axios.create({
    baseURL: `https://www.googleapis.com/oauth2`,
    headers: {
      authorization: `Bearer ${creds.access_token}`,
      accept: "application/json",
    },
  });
  return client.request({
    method: "GET",
    url: `/v1/userinfo?access_token=${creds.access_token}`,
  });
};

const userGoogleLogin = (userCred) => {
  return request({
    url: "/api/v1/auth/externalLogin",
    method: "post",
    body: userCred,
  });
};
const generateSignUpOtp = (userCred) => {
  return request({
    url: "/api/v1/auth/generateSignupOTP",
    method: "post",
    body: userCred,
  });
};
const verifySignUpOtp = (userCred) => {
  return request({
    url: "/api/v1/auth/verifySignupOTP",
    method: "post",
    body: userCred,
  });
};
const registerUser = (userCred) => {
  return request({
    url: "/api/v1/auth/signup",
    method: "post",
    body: userCred,
  });
};
const loginUser = (userCred) => {
  return request({
    url: "/api/v1/auth/login",
    method: "post",
    body: userCred,
  });
};

//reset-password-api
const generateResetPasswordOtp = (userCred) => {
  return request({
    url: "/api/v1/auth/generateResetPasswordOTP",
    method: "post",
    body: userCred,
  });
};
const verifyResetPasswordOtp = (userCred) => {
  return request({
    url: "/api/v1/auth/verifyResetPasswordOTP",
    method: "post",
    body: userCred,
  });
};
const resetPassword = (userCred) => {
  return request({
    url: "/api/v1/auth/resetPassword",
    method: "post",
    body: userCred,
  });
};
const getSource = () => {
  return request({
    url: `api/v1/source/getSource`,
    method: "get",
  });
};
export const SignInApi = {
  getCredsGoogleLogin,
  userGoogleLogin,
  generateSignUpOtp,
  verifySignUpOtp,
  registerUser,
  loginUser,
  generateResetPasswordOtp,
  verifyResetPasswordOtp,
  resetPassword,
  getSource,
};
